import { CSSProperties, useEffect } from 'react';
import * as bd from 'react-basic-design';
import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useAccount } from '../../app/account-context';
import SvgHome from '../../assets/icons/Home';
import SvgLogin from '../../assets/icons/Login';
import SvgSync from '../../assets/icons/Sync';
import { notify } from '../../components/basic/notify';
import { T } from '../../components/basic/text';

export function Protected() {
    const account = useAccount();
    const navigate = useNavigate();
    const location = useLocation();

    function reconnect() {
        account.init().catch(ex => !ex.handled && notify.error(ex));
    }

    useEffect(() => {
        if (!!account.status) return;
        account.init().catch(notify.error);
    });

    const connecting_style: CSSProperties = { minHeight: 'calc(100vh - 80px)' };
    const logged_out_style: CSSProperties = { maxHeight: 601, minHeight: 'calc(100vh - 80px)' };
    return (
        <>
            {account.isConnecting() && (
                <div className="h-100 middle" style={connecting_style}>
                    <div className="m-e-2 spinner-grow text-info spinner-grow-sm animation-delay--0s"></div>
                    <div className="m-e-2 spinner-grow text-info spinner-grow-sm animation-delay--1s"></div>
                    <div className="m-e-2 spinner-grow text-info spinner-grow-sm animation-delay--2s"></div>
                </div>
            )}

            {account.isConnectionFailed() && (
                <div className="h-100 middle" style={connecting_style}>
                    <div className="text-center">
                        <T as="div" className="text-danger p-3">
                            connection-error
                        </T>
                        <button className="btn btn-link btn-icon text-dark" onClick={reconnect}>
                            <SvgSync />
                            <T className="p-s-2">retry</T>
                        </button>
                    </div>
                </div>
            )}

            {account.isConnected() && <Outlet />}

            {account.isLoggedOut() && (
                <div className="h-100 middle" style={logged_out_style}>
                    <div>
                        <T as="div">we-cannot-authenticate-you</T>
                        <dl className="pt-2">
                            <dd className="m-0">
                                <bd.Button onClick={reconnect}>
                                    <SvgSync fill="#06c" /> <T>retry</T>
                                </bd.Button>
                            </dd>
                            <dd className="m-0">
                                <bd.Button
                                    onClick={() => {
                                        const from = location.pathname + location.search;
                                        navigate('/login', { state: { from }, replace: true });
                                    }}
                                >
                                    <SvgLogin fill="#06c" /> <T>login</T>
                                </bd.Button>
                            </dd>
                            <dd className="m-0">
                                <bd.Button href="/">
                                    <SvgHome fill="#06c" /> <T>redirect-to-home-page</T>
                                </bd.Button>
                            </dd>
                        </dl>
                    </div>
                </div>
            )}

            {account.isForbidden() && <Outlet />}
        </>
    );
}
